// extracted by mini-css-extract-plugin
export default {"button":"ButtonBalance_button__6Qi78","labeltext":"ButtonBalance_labeltext__DnEPf","svgbtn":"ButtonBalance_svgbtn__YR0y0"};